export class AdmittedPetsModel {
    tag_no: string;
    pet_no: number;
    pet_name: string;
    checkedin: boolean;
    client_no: number;
    first_name: string;
    last_name: string;
    assigned_doctor: string;
    assigned_nurse1: string;
    tagdate: string;
    location: string;
    department: string;

    constructor(
        tag_no: string,
        pet_no: number,
        pet_name: string,
        checkedin: boolean,
        client_no: number,
        first_name: string,
        last_name: string,
        assigned_doctor: string,
        assigned_nurse1: string,
        tagdate: string,
        location: string,
        department: string
    ) {
        this.tag_no = tag_no;
        this.pet_no = pet_no;
        this.pet_name = pet_name;
        this.checkedin = checkedin;
        this.client_no = client_no;
        this.first_name = first_name;
        this.last_name = last_name;
        this.assigned_doctor = assigned_doctor;
        this.assigned_nurse1 = assigned_nurse1;
        this.tagdate = tagdate;
        this.location = location;
        this.department = department;
    }
}
